/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Scope_Point_2Inputs */

const en_svc_agents_scope_point_2 = /** @type {(inputs: Svc_Agents_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email triage and drafted replies`)
};

const lv_svc_agents_scope_point_2 = /** @type {(inputs: Svc_Agents_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-pastu šķirošana un atbilžu sagatavošana`)
};

/**
* | output |
* | --- |
* | "Email triage and drafted replies" |
*
* @param {Svc_Agents_Scope_Point_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_scope_point_2 = /** @type {((inputs?: Svc_Agents_Scope_Point_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Scope_Point_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_scope_point_2(inputs)
	return en_svc_agents_scope_point_2(inputs)
});